import { useEffect } from 'react';

export function usePageMeta(title: string, description: string, noindex = false) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    const values: [string, string][] = [
      ['meta[name="description"]', description],
      ['meta[property="og:title"]', title],
      ['meta[property="og:description"]', description],
    ];
    const previous = values.map(([selector, content]) => {
      const element = document.querySelector<HTMLMetaElement>(selector);
      const old = element?.content;
      if (element) element.content = content;
      return { element, old };
    });
    let robots: HTMLMetaElement | null = null;
    if (noindex) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      robots.content = 'noindex, nofollow';
      document.head.appendChild(robots);
    }
    return () => {
      document.title = previousTitle;
      previous.forEach(({ element, old }) => { if (element && old !== undefined) element.content = old; });
      robots?.remove();
    };
  }, [title, description, noindex]);
}
